import ResultsGridUnitTypesV2 from "@wesstron/utils/results/resultsUnitTypes";
import {
    getFirstCycleIndex,
    getTimeFromInseminationToPartuition,
} from "../utils/SettingsUtils";

export const technologyGroupList = [
    {name: "planTypes.reproduction", isFullWidth: true, group: "reproduction"},
    "inseminatedGiltsAmount",
    "inseminatedSowsAmount",
    "inseminatedAmount",
    "usgAmount",
    "giltsInseminationEffectiveness",
    "sowsInseminationEffectiveness",
    "inseminationEffectiveness",
    "farrowingSows",
    "repetitionGiltsAmount",
    "repetitionSowsAmount",
    "repetitionAmount",
    "averageRepetitionTime",
    "averageSeparationToInseminationDays",
    {name: "planTypes.parturitions", isFullWidth: true, group: "gestation"},
    "expectedFarrowing",
    "farrowedAmount",
    "shiftFarrowDay",
    "giltsFarrowingEffectiveness",
    "sowsFarrowingEffectiveness",
    "farrowingEffectiveness",
    "bornPiglets",
    "averageBornPigletsForSow",
    "aliveBornPiglets",
    "aliveBornPigletsForSow",
    "weakBornPiglets",
    "weakBornPigletsForSow",
    "weakToAlivePigletsRatio",
    "mummyBornPiglets",
    "mummyBornPigletsForSow",
    "deadBornPiglets",
    "deadBornPigletsForSow",
    "averagePigletWeight",
    "numberOfPigletBySow",
    "fostering",
    {name: "separation", isFullWidth: true, group: "weaning"},
    "separatedLitters",
    "separationsToPigletHouse",
    "separationsToBabyRoom",
    "separatedPiglets",
    "separatedPigletForSow",
    "weanedPerFarrowing",
    "separatedWeight",
    "averageSeparatedPigletWeight",
    "pigletsMortality",
    "deadPiglets",
    "deadPigletsForSow",
    "lactationDays",
    "culledSows",
    {name: "SType.4", isFullWidth: true, group: "babyRoom"},
    "separationsFromBabyRoom",
    "babyRoomFall",
];

export const weekAndMonthList = [
    {name: "animalKind.0", isFullWidth: true, group: "sows"},
    "sowInsertionAmount",
    "sowFallAmount",
    "sowSellAmount",
    {name: "animalKind.2", isFullWidth: true, group: "weaners"},
    "pigletInserted",
    "pigletFallAmount",
    "pigletFallWeight",
    "pigletSellAmount",
    "pigletSellWeight",
    {name: "animalKind.3", isFullWidth: true, group: "finisher"},
    "pigletReclassifiedToPorker",
    "porkerInserted",
    "porkerFallAmount",
    "porkerFallWeight",
    "porkerSellAmount",
    "porkerSellWeight",
    {name: "animalKind.5", isFullWidth: true, group: "gilts"},
    "giltInserted",
    "giltFallAmount",
    "giltFallWeight",
    "giltSellAmount",
    "giltSellWeight",
    {name: "planTypes.reproduction", isFullWidth: true, group: "reproduction"},
    "inseminatedGiltsAmount",
    "inseminatedSowsAmount",
    "inseminatedAmount",
    "usgAmount",
    "repetitionGiltsAmount",
    "repetitionSowsAmount",
    "repetitionAmount",
    "retention",
    {name: "planTypes.parturitions", isFullWidth: true, group: "gestation"},
    "expectedFarrowing",
    "farrowedAmount",
    "shiftFarrowDay",
    "bornPiglets",
    "averageBornPigletsForSow",
    "aliveBornPiglets",
    "aliveBornPigletsForSow",
    "weakBornPiglets",
    "weakBornPigletsForSow",
    "weakToAlivePigletsRatio",
    "mummyBornPiglets",
    "mummyBornPigletsForSow",
    "deadBornPiglets",
    "deadBornPigletsForSow",
    "averagePigletWeight",
    "fostering",
    {name: "separation", isFullWidth: true, group: "weaning"},
    "separatedLitters",
    "separationsToPigletHouse",
    "separatedPiglets",
    "separationsToBabyRoom",
    "separatedPigletForSow",
    "separatedWeight",
    "averageSeparatedPigletWeight",
    "deadPiglets",
    "culledSows",
    {name: "SType.4", isFullWidth: true, group: "babyRoom"},
    "separationsFromBabyRoom",
    "babyRoomFall",
];

export const porkerAndPigletList = [
    {name: "general", isFullWidth: true, group: "generalGroups"},
    "currentAmount",
    "generalInserted",
    "generalInsertedToGroup",
    "generalFallAmount",
    "generalFallWeight",
    "generalMortality",
    "generalSellAmount",
    "generalSellWeight",
    "generalSellWeightTotal",
    "generalReclassified",
    "generalTransferredTo",
    "generalTransferredFrom",
    "generalGain",
    "generalSellGain",
    {name: "animalKind.2", isFullWidth: true, group: "weanerGroups"},
    "pigletInserted",
    "pigletFallAmount",
    "pigletFallWeight",
    "pigletMortality",
    "pigletSellAmount",
    "pigletSellWeight",
    "pigletSellWeightTotal",
    "pigletReclassified",
    "pigletTransferredTo",
    "pigletTransferredFrom",
    "pigletGain",
    "pigletSellGain",
    "timeOnPigletHouse",
    {name: "animalKind.5", isFullWidth: true, group: "giltGroups"},
    "giltInserted",
    "giltFallAmount",
    "giltFallWeight",
    "giltMortality",
    "giltSellAmount",
    "giltSellWeight",
    "giltSellWeightTotal",
    "giltReclassified",
    "giltTransferredTo",
    "giltTransferredFrom",
    {name: "animalKind.3", isFullWidth: true, group: "finisherGroups"},
    "pigletReclassifiedToPorker",
    "porkerInserted",
    "porkerFallAmount",
    "porkerFallWeight",
    "porkerMortality",
    "porkerSellAmount",
    "porkerSellWeight",
    "porkerSellWeightTotal",
    "porkerReclassified",
    "porkerTransferredTo",
    "porkerTransferredFrom",
    "porkerGain",
    "porkerSellGain",
    "timeOnPorkHouse",
];

const farrowedAmountFormula =
    "({{inseminatedGiltsAmount}} + {{inseminatedSowsAmount}}) * ({{farrowingEffectiveness}} / 100)";

const farrowedAmountHTMLFormula =
    "<mo>(</mo><mi>{{inseminatedGiltsAmount}}</mi><mo>+</mo><mi>{{inseminatedSowsAmount}}</mi><mo>)</mo><mo>⋅</mo><mi>{{farrowingEffectiveness}}</mi>";

export const resultTargetList = [
    {name: "animalKind.0", isFullWidth: true},
    {
        name: "planTypes.insertedSows",
        sqlKey: "sowInsertionAmount",
        min: 0,
        max: 10,
        default: [1, 10],
    },
    {
        name: "planTypes.numberOfFallenSows",
        sqlKey: "sowFallAmount",
        min: 0,
        max: 10,
        default: [1, 10],
    },
    {
        name: "planTypes.numberOfSowsSold",
        sqlKey: "sowSellAmount",
        min: 0,
        max: 10,
        default: [1, 10],
    },

    {name: "general", isFullWidth: true},
    {
        name: "currentAnimalAmount",
        sqlKey: "currentAmount",
        min: 1,
        max: 10,
        default: [1, 10],
    },
    {
        name: "animalsInserted",
        sqlKey: "generalInserted",
        min: 1,
        max: 10,
        default: [1, 10],
    },
    {
        name: "animalsInsertedToGroup",
        sqlKey: "generalInsertedToGroup",
        min: 1,
        max: 10,
        default: [1, 10],
    },
    {
        name: "numberOfFallenAnimals",
        sqlKey: "generalFallAmount",
        min: 1,
        max: 10,
        default: [1, 10],
    },
    {
        name: "averageWeightOfDeadAnimals",
        sqlKey: "generalFallWeight",
        min: 1,
        max: 10,
        default: [1, 10],
    },
    {
        name: "animalMortality",
        sqlKey: "generalMortality",
        min: 1,
        max: 10,
        default: [1, 10],
    },
    {
        name: "numberOfSoldAnimals",
        sqlKey: "generalSellAmount",
        min: 1,
        max: 10,
        default: [1, 10],
    },
    {
        name: "averageWeightOfSoldAnimals",
        sqlKey: "generalSellWeight",
        min: 1,
        max: 10,
        default: [1, 10],
    },
    {
        name: "weightOfSoldAnimals",
        sqlKey: "generalSellWeightTotal",
        min: 1,
        max: 10,
        default: [1, 10],
    },
    {
        name: "reclassifiedAnimals",
        sqlKey: "generalReclassified",
        min: 1,
        max: 10,
        default: [1, 10],
    },
    {
        name: "animalsTransferredToGroup",
        sqlKey: "generalTransferredTo",
        min: 1,
        max: 10,
        default: [1, 10],
    },
    {
        name: "animalsTransferredToOtherGroup",
        sqlKey: "generalTransferredFrom",
        min: 1,
        max: 10,
        default: [1, 10],
    },
    {
        name: "generalGain",
        sqlKey: "generalGain",
        min: 1,
        max: 10,
        default: [1, 10],
    },
    {
        name: "generalSellGain",
        sqlKey: "generalSellGain",
        min: 1,
        max: 10,
        default: [1, 10],
    },
    {name: "animalKind.2", isFullWidth: true},
    {
        name: "planTypes.insertedWeaners",
        sqlKey: "pigletInserted",
        min: 0,
        max: 10,
        default: [1, 10],
    },
    {
        name: "planTypes.numberOfFallenPiglets",
        sqlKey: "pigletFallAmount",
        min: 0,
        max: 10,
        default: [1, 10],
    },
    {
        name: "planTypes.weightOfFallenPiglets",
        sqlKey: "pigletFallWeight",
        min: 1,
        max: 10,
        default: [1, 10],
    },
    {
        name: "planTypes.numberOfPigletsSold",
        sqlKey: "pigletSellAmount",
        min: 0,
        max: 10,
        default: [1, 10],
    },
    {
        name: "planTypes.averagePigletSellWeight",
        sqlKey: "pigletSellWeight",
        min: 1,
        max: 10,
        default: [1, 10],
    },
    {
        name: "weightOfSoldWeaners",
        sqlKey: "pigletSellWeightTotal",
        min: 1,
        max: 10,
        default: [1, 10],
    },
    {
        name: "planTypes.weanerMortality",
        sqlKey: "pigletMortality",
        min: 1,
        max: 10,
        default: [1, 10],
    },
    {
        name: "planTypes.reclassifiedPiglets",
        sqlKey: "pigletReclassified",
        min: 0,
        max: 10,
        default: [1, 10],
    },
    {
        name: "weanersTransferredGroup",
        sqlKey: "pigletTransferredTo",
        min: 1,
        max: 10,
        default: [1, 10],
    },
    {
        name: "weanersTransferredToOtherGroup",
        sqlKey: "pigletTransferredFrom",
        min: 1,
        max: 10,
        default: [1, 10],
    },
    {
        name: "weanerGain",
        sqlKey: "pigletGain",
        min: 1,
        max: 10,
        default: [1, 10],
    },
    {
        name: "weanerSellGain",
        sqlKey: "pigletSellGain",
        min: 1,
        max: 10,
        default: [1, 10],
    },
    {
        name: "timeOnPigletHouse",
        sqlKey: "timeOnPigletHouse",
        min: 1,
        max: 10,
        default: [1, 10],
    },

    {name: "animalKind.5", isFullWidth: true},
    {
        name: "giltInserted",
        sqlKey: "giltInserted",
        min: 0,
        max: 10,
        default: [1, 10],
    },
    {
        name: "planTypes.numberOfFallenRenovationSows",
        sqlKey: "giltFallAmount",
        min: 0,
        max: 10,
        default: [1, 10],
    },
    {
        name: "averageWeightOfDeadGilts",
        sqlKey: "giltFallWeight",
        min: 1,
        max: 10,
        default: [1, 10],
    },
    {
        name: "planTypes.numberOfRenovationSowsSold",
        sqlKey: "giltSellAmount",
        min: 0,
        max: 10,
        default: [1, 10],
    },
    {
        name: "averageWeightOfSoldGilts",
        sqlKey: "giltSellWeight",
        min: 1,
        max: 10,
        default: [1, 10],
    },
    {
        name: "weightOfSoldGilts",
        sqlKey: "giltSellWeightTotal",
        min: 1,
        max: 10,
        default: [1, 10],
    },
    {
        name: "giltMortality",
        sqlKey: "giltMortality",
        min: 1,
        max: 10,
        default: [1, 10],
    },
    {
        name: "reclassifiedGilts",
        sqlKey: "giltReclassified",
        min: 1,
        max: 10,
        default: [1, 10],
    },
    {
        name: "giltsTransferredToGroup",
        sqlKey: "giltTransferredTo",
        min: 1,
        max: 10,
        default: [1, 10],
    },
    {
        name: "giltsTransferredToOtherGroup",
        sqlKey: "giltTransferredFrom",
        min: 1,
        max: 10,
        default: [1, 10],
    },

    {name: "animalKind.3", isFullWidth: true},
    {
        name: "planTypes.pigletReclassifiedToPorker",
        sqlKey: "pigletReclassifiedToPorker",
        min: 0,
        max: 10,
        default: [1, 10],
    },
    {
        name: "planTypes.insertedPorkers",
        sqlKey: "porkerInserted",
        min: 0,
        max: 10,
        default: [1, 10],
    },
    {
        name: "planTypes.numberOfFallenPorkers",
        sqlKey: "porkerFallAmount",
        min: 0,
        max: 10,
        default: [1, 10],
    },
    {
        name: "planTypes.weightOfFallenPorkers",
        sqlKey: "porkerFallWeight",
        min: 1,
        max: 10,
        default: [1, 10],
    },
    {
        name: "planTypes.numberOfPorkersSold",
        sqlKey: "porkerSellAmount",
        min: 0,
        max: 10,
        default: [1, 10],
    },
    {
        name: "planTypes.averagePorkerSellWeight",
        sqlKey: "porkerSellWeight",
        min: 1,
        max: 10,
        default: [1, 10],
    },
    {
        name: "weightOfFinisherSold",
        sqlKey: "porkerSellWeightTotal",
        min: 1,
        max: 10,
        default: [1, 10],
    },
    {
        name: "planTypes.porkerMortality",
        sqlKey: "porkerMortality",
        min: 1,
        max: 10,
        default: [1, 10],
    },
    {
        name: "finisherReclassified",
        sqlKey: "porkerReclassified",
        min: 1,
        max: 10,
        default: [1, 10],
    },
    {
        name: "finisherTransferredToGroup",
        sqlKey: "porkerTransferredTo",
        min: 1,
        max: 10,
        default: [1, 10],
    },
    {
        name: "finisherTransferredToOtherGroup",
        sqlKey: "porkerTransferredFrom",
        min: 1,
        max: 10,
        default: [1, 10],
    },
    {
        name: "finisherGain",
        sqlKey: "porkerGain",
        min: 1,
        max: 10,
        default: [1, 10],
    },
    {
        name: "finisherSellGain",
        sqlKey: "porkerSellGain",
        min: 1,
        max: 10,
        default: [1, 10],
    },
    {
        name: "timeOnPorkHouse",
        sqlKey: "timeOnPorkHouse",
        min: 1,
        max: 10,
        default: [1, 10],
    },

    {name: "planTypes.reproduction", isFullWidth: true},
    {
        name: "planTypes.inseminatedRenovationSows",
        sqlKey: "inseminatedGiltsAmount",
        min: 1,
        max: 200,
        default: [36, 40],
    },
    {
        name: "planTypes.inseminatedSows",
        sqlKey: "inseminatedSowsAmount",
        min: 1,
        max: 400,
        default: [60, 80],
    },
    {
        name: "planTypes.inseminatedAllSows",
        sqlKey: "inseminatedAmount",
        calc: true,
        formula: "{{inseminatedGiltsAmount}} + {{inseminatedSowsAmount}}",
        htmlFormula:
            "<mrow><mi>{{inseminatedGiltsAmount}}</mi><mo>+</mo><mi>{{inseminatedSowsAmount}}</mi></mrow>",
    }, // loszki + maciory
    {
        name: "planTypes.allUsgs",
        sqlKey: "usgAmount",
        min: 0,
        max: 100,
        default: [1, 100],
        custom: "{{amount}} / {{inseminated}} * 100",
        unit: ResultsGridUnitTypesV2.PERCENT,
    }, // cel w procentach, wartosc jako ilosc
    {
        name: "planTypes.giltsInseminationEffectiveness",
        sqlKey: "giltsInseminationEffectiveness",
        min: 0,
        max: 100,
        default: [95, 100],
    },
    {
        name: "planTypes.sowsInseminationEffectiveness",
        sqlKey: "sowsInseminationEffectiveness",
        min: 0,
        max: 100,
        default: [95, 100],
    },
    {
        name: "planTypes.inseminationEffectiveness",
        sqlKey: "inseminationEffectiveness",
        min: 0,
        max: 100,
        default: [95, 100],
    },
    {
        name: "planTypes.parturitionedSowsAmount",
        sqlKey: "farrowingSows",
        calc: true,
        component: "ResultsV2InseminationEffectivenessTarget",
    }, // jezeli jakakolwiek miala porod, a liczba to nie 0
    {
        name: "planTypes.repetitionsForRenovationSows",
        sqlKey: "repetitionGiltsAmount",
        min: 0,
        max: 100,
        default: [0, 5],
    },
    {
        name: "planTypes.repetitionsForSows",
        sqlKey: "repetitionSowsAmount",
        min: 0,
        max: 100,
        default: [0, 5],
    },
    {
        name: "planTypes.numberOfRepetitions",
        sqlKey: "repetitionAmount",
        calc: true,
        formula: "{{repetitionGiltsAmount}} + {{repetitionSowsAmount}}",
        htmlFormula:
            "<mrow><mi>{{repetitionGiltsAmount}}</mi><mo>+</mo><mi>{{repetitionSowsAmount}}</mi></mrow>",
    }, // loszki + maciory
    {
        name: "planTypes.avgBrakeFromInsToRep",
        sqlKey: "averageRepetitionTime",
        min: 1,
        max: 50,
        default: [1, 21],
    },
    {
        name: "planTypes.avgBrakeFromSepToIns",
        sqlKey: "averageSeparationToInseminationDays",
        min: 1,
        max: 30,
        default: [1, 4],
    },
    {
        name: "planTypes.retention",
        sqlKey: "retention",
        min: 0,
        max: 100,
        default: [90, 100],
    },
    {
        name: "planTypes.averageDaysFromEntryToFirstInsemination",
        sqlKey: "averageDaysFromEntryToFirstInsemination",
        min: 0,
        max: 500,
        default: [150, 250],
    },
    {
        name: "planTypes.inseminationRepetitionPercent",
        sqlKey: "inseminationRepetitionPercent",
        min: 0,
        max: 100,
        default: [0, 20],
    },
    {
        name: "planTypes.averageWeaningToInseminationInterval",
        sqlKey: "averageWeaningToInseminationInterval",
        min: 0,
        max: 50,
        default: [4, 10],
    },

    {name: "planTypes.parturitions", isFullWidth: true},
    {
        name: "planTypes.expectedParturitions",
        sqlKey: "expectedFarrowing",
        calc: true,
        component: "ResultsV2ExpectedFarrowingTarget",
    }, // jezeli jakakolwiek ma opozniony porod i jest niewyproszona to na czerwono
    {
        name: "planTypes.parturitionedSows",
        sqlKey: "farrowedAmount",
        calc: true,
        formula: farrowedAmountFormula,
        round: "ceil",
        htmlFormula: `<mrow>${farrowedAmountHTMLFormula}</mrow>`,
    }, // skutecznosc wyproszen * ilosc pokrytych
    {
        name: "planTypes.parturitionDiffDays",
        sqlKey: "shiftFarrowDay",
        min: -5,
        max: 5,
        default: [-2, 2],
    },
    {
        name: "planTypes.giltsFarrowingEffectiveness",
        sqlKey: "giltsFarrowingEffectiveness",
        min: 1,
        max: 100,
        default: [93, 100],
    },
    {
        name: "planTypes.sowsFarrowingEffectiveness",
        sqlKey: "sowsFarrowingEffectiveness",
        min: 1,
        max: 100,
        default: [93, 100],
    },
    {
        name: "planTypes.parturitionEffectiveness",
        sqlKey: "farrowingEffectiveness",
        min: 1,
        max: 100,
        default: [93, 100],
    },
    {
        name: "planTypes.allBornPiglets",
        sqlKey: "bornPiglets",
        calc: true,
        formula: `${farrowedAmountFormula} * {{averageBornPigletsForSow}}`,
        round: "ceil",
        htmlFormula: `<mrow>${farrowedAmountHTMLFormula}<mo>⋅</mo><mi>{{averageBornPigletsForSow}}</mi></mrow>`,
    }, // z maciory
    {
        name: "planTypes.allBornPigletsPerSow",
        sqlKey: "averageBornPigletsForSow",
        min: 8,
        max: 40,
        default: [8, 18],
        step: 0.1,
    },
    {
        name: "planTypes.bornHealthyPiglets",
        sqlKey: "aliveBornPiglets",
        calc: true,
        formula: `${farrowedAmountFormula} * {{aliveBornPigletsForSow}}`,
        round: "ceil",
        htmlFormula: `<mrow>${farrowedAmountHTMLFormula}<mo>⋅</mo><mi>{{aliveBornPigletsForSow}}</mi></mrow>`,
    }, // z maciory
    {
        name: "planTypes.bornHealthyPigletsPerSow",
        sqlKey: "aliveBornPigletsForSow",
        min: 8,
        max: 40,
        default: [8, 18],
        step: 0.1,
    },
    {
        name: "planTypes.bornWeakPiglets",
        sqlKey: "weakBornPiglets",
        calc: true,
        formula: `${farrowedAmountFormula} * {{weakBornPigletsForSow}}`,
        round: "ceil",
        htmlFormula: `<mrow>${farrowedAmountHTMLFormula}<mo>⋅</mo><mi>{{weakBornPigletsForSow}}</mi></mrow>`,
    }, // z maciory
    {
        name: "planTypes.bornWeakPigletsPerSow",
        sqlKey: "weakBornPigletsForSow",
        min: 0,
        max: 40,
        default: [0, 1],
        step: 0.1,
    },
    {
        name: "planTypes.percentageOfWeakPigletsBornRelativeToHealthy",
        sqlKey: "weakToAlivePigletsRatio",
        min: 0,
        max: 100,
        default: [0, 2],
    },
    {
        name: "planTypes.bornMummyPiglets",
        sqlKey: "mummyBornPiglets",
        calc: true,
        formula: `${farrowedAmountFormula} * {{mummyBornPigletsForSow}}`,
        round: "ceil",
        htmlFormula: `<mrow>${farrowedAmountHTMLFormula}<mo>⋅</mo><mi>{{mummyBornPigletsForSow}}</mi></mrow>`,
    }, // z maciory
    {
        name: "planTypes.bornMummyPigletsPerSow",
        sqlKey: "mummyBornPigletsForSow",
        min: 0,
        max: 40,
        default: [0, 1],
        step: 0.1,
    },
    {
        name: "planTypes.bornDeadPiglets",
        sqlKey: "deadBornPiglets",
        calc: true,
        formula: `${farrowedAmountFormula} * {{deadBornPigletsForSow}}`,
        round: "ceil",
        htmlFormula: `<mrow>${farrowedAmountHTMLFormula}<mo>⋅</mo><mi>{{deadBornPigletsForSow}}</mi></mrow>`,
    }, // z maciory
    {
        name: "planTypes.bornDeadPigletsPerSow",
        sqlKey: "deadBornPigletsForSow",
        min: 0,
        max: 40,
        default: [0, 1],
        step: 0.1,
    },
    {
        name: "planTypes.averageBornPigletsWeight",
        sqlKey: "averagePigletWeight",
        min: 100,
        max: 10000,
        default: [1000, 2000],
        step: 0.1,
    },
    {
        name: "numberOfPigletsBySow",
        sqlKey: "numberOfPigletBySow",
        min: 0,
        max: 1000,
        default: [0, 200],
    },
    {
        name: "controlLists.mainView.fosteringTitle",
        sqlKey: "fostering",
        min: 0,
        max: 100,
        default: [0, 100],
    },
    {
        name: "planTypes.averageParityOfFarrowedSows",
        sqlKey: "averageParityOfFarrowedSows",
        min: 0,
        max: 100,
        default: [0, 100],
    },
    {
        name: "planTypes.aliveBornPerMatedFemalePerYear",
        sqlKey: "aliveBornPerMatedFemalePerYear",
        min: 0,
        max: 20,
        default: [0, 5],
    },
    {
        name: "planTypes.numberOfLittersPerMatedFemalePerYear",
        sqlKey: "numberOfLittersPerMatedFemalePerYear",
        min: 0,
        max: 100,
        default: [25, 40],
    },
    {
        name: "planTypes.percentSmallLitters",
        sqlKey: "percentSmallLitters",
        min: 0,
        max: 50,
        default: [0, 20],
    },
    {
        name: "planTypes.averageGestationLength",
        sqlKey: "averageGestationLength",
        min: 100,
        max: 150,
        default: [110, 120],
    },
    {
        name: "planTypes.averageFarrowingInterval",
        sqlKey: "averageFarrowingInterval",
        min: 100,
        max: 250,
        default: [120, 180],
    },

    {name: "separation", isFullWidth: true},
    {
        name: "planTypes.separatedSows",
        sqlKey: "separatedLitters",
        calc: true,
        formula: farrowedAmountFormula,
        round: "ceil",
    }, // skutecznosc wyproszen
    {
        name: "numberOfSeparatedPerSeparation",
        sqlKey: "separatedPiglets",
        calc: true,
        formula: `${farrowedAmountFormula} * {{separatedPigletForSow}}`,
        round: "ceil",
        htmlFormula: `<mrow>${farrowedAmountHTMLFormula}<mo>⋅</mo><mi>{{separatedPigletForSow}}</mi></mrow>`,
    }, // z maciory
    {
        name: "numberOfSeparatedPerFarrowing",
        sqlKey: "weanedPerFarrowing",
        min: 2,
        max: 20,
        default: [12, 16],
        step: 0.1,
    },
    {
        name: "planTypes.amountOfSeparatedPigletsPerSow",
        sqlKey: "separatedPigletForSow",
        min: 5,
        max: 20,
        default: [12, 16],
        step: 0.1,
    },
    // { name: "planTypes.weightOfPitcherWeight", sqlKey: "separatedLitterWeight", calc: true, formula: "{{averageSeparatedPigletWeight}} * {{separatedPigletForSow}}", htmlFormula: "<mrow><mi>{{averageSeparatedPigletWeight}}</mi><mo>⋅</mo><mi>{{separatedPigletForSow}}</mi></mrow>" }, // srednia waga odsadzonego prosiaka
    {
        name: "planTypes.litterWeight",
        sqlKey: "separatedWeight",
        calc: true,
        formula: `${farrowedAmountFormula} * {{separatedPigletForSow}} * {{averageSeparatedPigletWeight}}`,
        round: "ceil",
        htmlFormula: `<mrow>${farrowedAmountHTMLFormula}<mo>⋅</mo><mi>{{separatedPigletForSow}}</mi><mo>⋅</mo><mi>{{averageSeparatedPigletWeight}}</mi></mrow>`,
    }, // srednia waga odsadzonego prosiaka
    {
        name: "planTypes.averageWeightOfSeparatedPiglet",
        sqlKey: "averageSeparatedPigletWeight",
        min: 400,
        max: 12000,
        default: [5000, 7000],
        step: 10,
    },
    {
        name: "planTypes.pigletsMortality",
        sqlKey: "pigletsMortality",
        min: 0,
        max: 30,
        default: [0, 10],
    },
    {
        name: "planTypes.numberOfFallenPigs",
        sqlKey: "deadPiglets",
        min: 0,
        max: 30,
        default: [0, 100],
    }, // smiertelnosc prosiat
    {
        name: "planTypes.numberOfFallenPigsForSow",
        sqlKey: "deadPigletsForSow",
        min: 0,
        max: 30,
        default: [0, 10],
    }, // smiertelnosc prosiat
    {
        name: "sowResults.lactationDays",
        sqlKey: "lactationDays",
        min: 0,
        max: 40,
        default: [24, 30],
    },
    {
        name: "separatedToBabyRoom",
        sqlKey: "separationsToBabyRoom",
        min: 0,
        max: 200,
        default: [0, 30],
    },
    {
        name: "modals.editSowCycle.separationToPiglethouse",
        sqlKey: "separationsToPigletHouse",
        min: 0,
        max: 3000,
        default: [0, 30],
    },
    {
        name: "culledSows",
        sqlKey: "culledSows",
        min: 0,
        max: 50,
        default: [0, 3],
    },
    {name: "SType.4", isFullWidth: true},
    {
        name: "separatedFromBabyRoom",
        sqlKey: "separationsFromBabyRoom",
        min: 0,
        max: 200,
        default: [0, 30],
    },
    {
        name: "babyRoomFall",
        sqlKey: "babyRoomFall",
        min: 0,
        max: 200,
        default: [0, 30],
    },
    {
        name: "planTypes.weanedPigletsPerMatedFemalePerYear",
        sqlKey: "weanedPigletsPerMatedFemalePerYear",
        min: 0,
        max: 100,
        default: [20, 40],
    },
    {
        name: "planTypes.preweaningPigletsMortalityRate",
        sqlKey: "preweaningPigletsMortalityRate",
        min: 0,
        max: 30,
        default: [0, 10],
    },
    {
        name: "planTypes.averageWeaningAge",
        sqlKey: "averageWeaningAge",
        min: 20,
        max: 80,
        default: [30, 50],
    },
];

function getFirstCycleIndexParams() {
    return [getFirstCycleIndex()];
}

function getInseminationWithCycleParams() {
    return [-getTimeFromInseminationToPartuition(), getFirstCycleIndex()];
}

function getInseminationEffectivenessParams() {
    return [-getTimeFromInseminationToPartuition()];
}

function retentionParams() {
    const firstCycleIndex = getFirstCycleIndex();
    return [firstCycleIndex, firstCycleIndex];
}

function retentionDetailParams() {
    const firstCycleIndex = getFirstCycleIndex();
    return [firstCycleIndex, firstCycleIndex, firstCycleIndex, firstCycleIndex];
}

export const getParametersFunction = {
    inseminatedGiltsAmount: getFirstCycleIndexParams,
    inseminatedSowsAmount: getFirstCycleIndexParams,
    giltsFarrowingEffectiveness: getFirstCycleIndexParams,
    sowsFarrowingEffectiveness: getFirstCycleIndexParams,
    repetitionGiltsAmount: getFirstCycleIndexParams,
    repetitionSowsAmount: getFirstCycleIndexParams,
    giltsInseminationEffectiveness: {
        results: getFirstCycleIndexParams,
        summary: getInseminationWithCycleParams,
        details: getFirstCycleIndexParams,
    },
    sowsInseminationEffectiveness: {
        results: getFirstCycleIndexParams,
        summary: getInseminationWithCycleParams,
        details: getFirstCycleIndexParams,
    },
    inseminationEffectiveness: {
        results: null,
        summary: getInseminationEffectivenessParams,
        details: null,
    },
    retention: {
        results: retentionParams,
        summary: retentionParams,
        details: retentionDetailParams,
    },
};
